module.exports = __webpack_public_path__ + "img/location.e5d63f3a.svg";